export class UserSiteMapNAccessDTO{
   userId: string;
   clientId: string;
   rcoId: string;
   auditFirmId: string;
   companyId: string;
   siteId: string;
   roleId: string;
   enableShowAllRecords: string;
   enableAllTransaction: string;
   
}